// extracted by mini-css-extract-plugin
module.exports = {"Button":"📚4-7-01-O4c","shape_pill":"📚4-7-03jKKR","shape_squared":"📚4-7-0K8xIL","selected":"📚4-7-02CjpU"};